import React from 'react';
import { deepCopy, isFunction, isMobile } from '@lhb/func';
import { Toast } from 'antd-mobile';
import { useAliveController } from 'react-activation';
// import { setStorage } from '@lhb/cache';
import { keepRoutes } from './keep-alive-config';
import { resolveLoginCallback, setLoginCallback } from '@/common/utils/login-callback';
import { getMallReportShareRedirectUrl } from './mall-report-share-redirect';

let locationFrom: any = {
  pathname: null,
  search: null,
};

const targetObj = {
  from: null,
  to: null
};
// 路由守卫
function routerAfterEach(from: any, to: any, routeList: any[], clearAlive: any) {
  // 在这里进行大数据埋点
  // console.log('form:', from);
  // console.log('to:', to);
  targetObj.from = from;
  targetObj.to = to;

  const result = routeList.find((item) => {
    return item.path === to.pathname;
  })?.meta;
  setLoginCallback(resolveLoginCallback(result?.logincallback, to.fullPath));
  if (result?.title) {
    // 兼容小程序/企微应用中没有window对象
    window && (window.document.title = `${isFunction(result?.title) ? result?.title(to) : result?.title}`); // 项目名-具体页面名称
  } else {
    process.env.NODE_ENV === 'development' && Toast.show('为了方便数据采集，请添加title！');
  }
  if (from?.pathname && to?.pathname) {
    const needClear = keepRoutes.every(item => {
      const matching = !item.formPathname.includes(from.pathname) || !item.toPathname.includes(to.pathname);
      const matchingReverse = !item.formPathname.includes(to.pathname) || !item.toPathname.includes(from.pathname);
      return matching && matchingReverse;
    });
    needClear && clearAlive();
  }
  if (process.env.NODE_ENV !== 'development') {
    // 大数据埋点，先发送离开页面的信息 再上传进入页面的信息
    // 兼容小程序/企微应用中没有window对象
    window && window.LHBbigdata && window.LHBbigdata.spa.beforeRouteLeave()(to, from);
    window && window.LHBbigdata && window.LHBbigdata.spa.beforeRouteEnter()(to, from);
  }
}

const RouterControl: React.FC<{
  locationTo: any;
  children: React.ReactNode;
  routeList: Array<any>;
}> = ({ children, locationTo, routeList }) => {
  const { clear } = useAliveController();
  const mallReportShareRedirectUrl = getMallReportShareRedirectUrl({
    pathname: locationTo.pathname,
    search: locationTo.search,
    hash: locationTo.hash,
    shouldRedirect: !isMobile(),
    targetBaseUrl: process.env.CONSOLE_PC_URL,
    currentOrigin: window.location.origin,
  });
  if (mallReportShareRedirectUrl) {
    window.location.replace(mallReportShareRedirectUrl);
    return null;
  }
  if (locationTo.pathname !== locationFrom.pathname || locationTo.search !== locationFrom.search) {
    // fullPath完全改变才会触发
    // 为大数据埋点设置fullPath，path

    routerAfterEach({
      ...locationFrom,
      fullPath: locationFrom.pathname ? locationFrom.pathname + locationFrom.search : '/',
      path: locationFrom.pathname || '/',
    }, {
      ...locationTo,
      fullPath: locationTo.pathname + locationTo.search,
      path: locationTo.pathname,
    }, routeList, clear);
  }
  // 提前备份location数据
  const location = {
    to: locationTo,
    from: locationFrom,
  };
  locationFrom = deepCopy(locationTo);
  // 先用这种存储方式
  // setStorage('ROUTER_GUARD', location);

  return (
    <>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child as React.ReactElement, {
          location
        });
      })}
    </>
  );
};

export default RouterControl;
